import React from 'react';
// import { Typography } from '../../../base'; // Assuming Typography is available in base
import {
    Wrapper,
    TopContentWrapper,
    HeadingText,
    SubheadingText,
    QuestionTextWrapper,
    QuestionText,
} from './EmptyChat.styles';
import { useTranslation } from 'react-i18next';
interface IEmptyChatProps {
    userName: string;
    questionText: string;
}

const EmptyChat: React.FC<IEmptyChatProps> = ({ userName, questionText }) => {
    const { t } = useTranslation();
    return (
        <Wrapper>
            <TopContentWrapper>
                <HeadingText variant="h3" component="h1">
                    {t('tools.chat.greetings', { name: userName })}
                </HeadingText>
                <SubheadingText variant="h5" component="p">
                    {t('tools.chat.greetingsSubtitle')}
                </SubheadingText>
            </TopContentWrapper>
            <QuestionTextWrapper>
                <QuestionText variant="subtitle1" component="p">
                    {questionText}
                </QuestionText>
            </QuestionTextWrapper>
        </Wrapper>
    );
};

export default EmptyChat;
